import { render } from "./TaskRetrievePage.vue?vue&type=template&id=db23e3e6"
import script from "./TaskRetrievePage.vue?vue&type=script&lang=js"
export * from "./TaskRetrievePage.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/apps/crm/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__